module.exports = __webpack_public_path__ + "img/zhenku2.8be871bf.png";